/**
 * Sticky add to cart con anuncio integrado — Apodemia
 * Aparece cuando el botón principal de compra de la PDP no está visible y se
 * esconde al llegar al footer. "Añadir" reutiliza el botón principal (variantes
 * y addons incluidos). El anuncio y el precio se recalculan al cambiar de
 * variante (evento pdp:variant): oferta → "Estás ahorrando X", stock bajo →
 * mensaje propio, si no → mensaje por defecto.
 */
(function () {
  'use strict';

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    var mainBtn = document.querySelector('[data-pdp-add-main]');
    if (!mainBtn) return; // sin PDP no hay sticky

    var annEl = bar.querySelector('[data-sticky-ann]');
    var nowEl = bar.querySelector('[data-sticky-now]');
    var wasEl = bar.querySelector('[data-sticky-was]');
    var priceWrap = bar.querySelector('[data-sticky-price]');
    var addBtn = bar.querySelector('[data-sticky-add]');

    var annDefault = bar.getAttribute('data-ann-default') || '';
    var annSale = bar.getAttribute('data-ann-sale') || '';
    var annLow = bar.getAttribute('data-ann-low') || '';

    // Umbral de stock bajo (del bloque de stock de la PDP, si existe)
    var stockEl = document.querySelector('[data-pdp-stock]');
    var lowThreshold = stockEl ? (parseInt(stockEl.getAttribute('data-threshold'), 10) || 10) : 10;

    // --- Añadir: delega en el botón principal de la PDP --------------------
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        mainBtn.click();
      });
    }

    // --- Sincroniza precio + anuncio al cambiar de variante ---------------
    function apply(v) {
      if (!v) return;
      var price = v.price;
      var compare = v.compare || 0;
      var onSale = compare > price;

      if (nowEl) nowEl.textContent = money(price);
      if (wasEl) {
        if (onSale) { wasEl.textContent = money(compare); wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }

      var isLow = v.managed && v.qty > 0 && v.qty <= lowThreshold;
      var text;
      if (onSale && annSale) {
        text = annSale.replace('[ahorro]', money(compare - price));
      } else if (isLow && annLow) {
        text = annLow;
      } else {
        text = annDefault;
      }
      if (annEl) annEl.textContent = text;

      if (addBtn) addBtn.disabled = !v.available;
      bar.classList.toggle('is-sale', onSale);
    }
    document.addEventListener('pdp:variant', function (e) { apply(e.detail); });

    // --- Mostrar / ocultar -------------------------------------------------
    var mainVisible = true;   // botón principal a la vista (arriba)
    var footerVisible = false;

    function update() {
      var show = !mainVisible && !footerVisible;
      if (show) {
        bar.hidden = false;
        // fuerza reflow para la transición al pasar de hidden a visible
        void bar.offsetHeight;
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    }
    // Al terminar la transición de salida, oculta del todo.
    bar.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'transform' && !bar.classList.contains('is-visible')) {
        bar.hidden = true;
      }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        mainVisible = entries[0].isIntersecting;
        update();
      }, { rootMargin: '0px 0px -20% 0px' }).observe(mainBtn);

      var footer = document.querySelector('.apodemia-footer') || document.querySelector('footer');
      if (footer) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          update();
        }, { rootMargin: '0px' }).observe(footer);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
